import React from 'react';
import {
	Dimensions,
	View,
	StyleSheet,
	TouchableHighlight,
	TouchableOpacity,
	useWindowDimensions,
} from 'react-native';
import colors from '../../../config/colors';
import I18n from '../../../components/shared/i18n/I18n.component';
import Header from '../../../components/shared/Header/Header.container';
import WebHeader from '../../../components/shared/Header/WebHeader.component';
import ReportsPageWrapper from '../../../components/web/ReportsPageWrapper/ReportsPageWrapper.component';
import TableContainer from '../../../components/web/ReactTable/Table.container';
import { Columns } from './EmployeeHoursReport.utils';
import getShadowStyle from '../../../config/shadow';
import Typography from '../../../components/shared/Typography/Typography.component';
import { i18nService } from '../../../services/i18n.service';
import Filters from '../../../components/web/Filters/Filters.component';
import ImageIcon from '../../../components/shared/Icon/ImageIcon.component';
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';
import ActionButtonContainer from '../../../components/shared/Buttons/ActionButton.container';
const clockInLogo = require('../../../../assets/images/clockLogo/michpal_clock_in.png');

export interface Props {
	worklogReportFormat: any;
	navigation: any;
	data: any[];
	onSort?: any;
	onLoadMore: any;
	totalData: any;
	filtersConfig: any;
	isSelectMode: boolean;
	selectedRows: any[];
	isAllSelected: boolean;
	canEdit: boolean;
	onSelectAll: (cheacked: boolean) => {};
	onSelect: () => {};
	onConfirmSelect: () => {};
	onCancelSelect: () => {};
	reqForSelect: () => {};
	onFilter: () => {};
	onDelete: (id: any) => {};
	onEdit: (id: any) => {};
	addReport: () => void;
}

const EmployeeHoursReportSummary = ({
	data,
	totalData,
	navigation,
	onSort,
	onLoadMore,
	filtersConfig,
	canEdit,
	addReport,
	onFilter,
	onEdit,
	onDelete,
	worklogReportFormat,
}: Props) => {
	const { height: windowHeight } = useWindowDimensions();
	

	return (
		<View
			style={{
				height: '100%',
			}}
		>
			<Header
				navigation={navigation}
				containerStyle={{ backgroundColor: colors.white }}
				component={WebHeader}
			/>
			<ReportsPageWrapper
				navigation={navigation}
				title={
					<View
						style={{
							flexDirection: 'row-reverse',
							width: '100%',
							justifyContent: 'space-between', 
						}}
					>
						<View style={{ flexDirection: 'row-reverse', alignItems: 'center' }}>
							<ImageIcon name="clockInLogo" width={108} height={30} style={{marginLeft: 12}} />
							<I18n size={20} weight='700' color={colors.primaryDarkBlue}>
								employeeHoursReport.employee.title
							</I18n>
						</View>
					
						<View style={{ flexDirection: 'row-reverse' }}>
							{canEdit && (
								
							<ActionButtonContainer onPress={addReport} overrideStyle={styles.addButton} hoverStyle={styles.addButtonHover}>
								<I18n size={16} weight='normal' color='white'>
									general.add
								</I18n>
								<ImageIcon name='plus' height={16} width={16} color='white' style={{ marginLeft: 4 }} />
							</ActionButtonContainer>
							)}
						</View>
					</View>
				}
				noHeader={true}
			>
				<View
					style={{
						flexDirection: 'row-reverse',
						width: '100%',
						justifyContent: 'space-between',
						zIndex: 100,
					}}
				>
					<View style={{ flexDirection: 'row-reverse' }}>
						<Filters
							config={filtersConfig}
							onChange={onFilter}
							customStyles={{
								container: {
									display: 'flex',
									flexDirection: 'row-reverse',
									justifyContent: 'flex-end',
									alignSelf: 'center',
								},
								filterContainer: {
									marginLeft: 10,
									marginVertical: 10,
									zIndex: 10001,
								},
							}}
						/>
					</View>
				</View>

				<View
					style={{
						maxHeight: windowHeight - 300,
					}}
				>
					<TableContainer
						keyName={''}
						headers={Columns(
							totalData ? totalData.total : null,
							onDelete,
							onEdit,
							canEdit,
							worklogReportFormat,
						)}
						data={data || []}
						getNextData={onLoadMore}
						onSort={onSort}
						hasFooter={true}
						selectedRowId={0}
					/>
				</View>
			</ReportsPageWrapper>
		</View>
	);
};

const styles = StyleSheet.create({
	newRequestButton: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		height: 40,
		backgroundColor: colors.lightPrimary,
		borderRadius: 45,
		...getShadowStyle(20, 'rgb(59, 112, 164)'),
		marginTop: 10,
		marginLeft: 10,
	},
	fabButton: {
		borderRadius: 30,
		width: 40,
		height: 40,
		marginTop: 10,
		marginLeft: 10,
		...getShadowStyle(20, 'rgb(59, 112, 164)'),
	},
	nextEmpButton: {
		marginRight: 10,
		marginTop: 10,
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		height: 40,
		paddingHorizontal: 5,
		backgroundColor: colors.lightPrimary,
		borderRadius: 10,
		...getShadowStyle(20, 'rgb(59, 112, 164)'),
	},
	addButton: {
		backgroundColor: colors.titlePrimary,
	},
	addButtonHover: {
		backgroundColor: colors.primaryDark,
	},
});

export default EmployeeHoursReportSummary;
